// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d2-scrollbar .el-scrollbar__wrap {\n  overflow: auto;\n}", ""]);
// Exports
module.exports = exports;
